export enum PaymentCardStatusEnum {
    expired = 'expired',
    lateCancellation = 'late_cancellation'
}
